import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

const styles = require('./WonderBar.less');
const cx = classnames.bind(styles);

export interface IWonderBarProps
{
    className?:string;
    isVisible?:boolean;
    onRef?:(ref:HTMLElement | null) => void;
}

@observer
export class WonderBar extends React.Component<IWonderBarProps, any>
{
    public static defaultProps:Partial<IWonderBarProps> = {
        isVisible: false
    };

    private _refHandlers = {
        base: (ref:HTMLElement | null) => controllers.ui.workbenchVisibility.setWonderBarDomRef(ref)
    };

    render()
    {
        const {isVisible, className, onRef} = this.props;

        if( !isVisible )
        {
            return null;
        }

        return (
            <div
                ref={onRef}
                className={cx('base', className)}
            >
                {this.props.children}
            </div>
        );
    }
}


